import sift from 'sift'
import { getDateOrValue } from '@utils/date-helpers'
import VariantMixin from '@mixins/variant-mixin'
import { mapState } from 'vuex'

export default {
  mixins: [
    VariantMixin(
      // Component name
      'lists',
      // Automatic generated computed properties
      [ 'listClass',
        'defaultLimit',
        'columns',
        'itemIndexes',
        'gutterWidth' ]
    )
  ],
  props: {
    serverItems: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number
    },
    internalScroll: Boolean
  },
  data: () => ({
    isMounted: false,
    loadedItems: [],
    filters: {},
    calculatedHeight: 'auto',
    pagination: {
      $limit: 0,
      $skip: 0
    },
  }),
  computed: {
    ...mapState('global', ['isSitecore']),
    ...mapState('responsive', { wHeight: 'height' }),
    items() {
      return !this.isMounted ? [] : this.filteredItems.filter((item, index) => index >= this.pagination.$skip && index < this.pagination.$limit)
    },
    total() {
      return this.filteredItems.length
    },
    filteredItems() {
      return this.loadedItems.filter(sift(this.filters))
    },
    allLoaded() {
      return this.total === this.items.length
    },
  },
  watch: {
    filters(val) {
      this.pagination.$limit = (this.limitOverwrite || this.defaultLimit)
      this.pagination.$skip = 0
    },
    height() {
      if (this.internalScroll) {
        this.calculateScroll()
      }
    },
    isMounted(val) {
      if (val) {
        this.$nextTick(() => {
          this.$emit('mounted')

          const variantIsRoomList = this.variant === "room-list"
          const queryParams = new URLSearchParams(window.location.search)
          if(variantIsRoomList) {
            const headerHeight = document.querySelector("#header").getBoundingClientRect().height
            var topOfElement = document.querySelector('.room-list.component').offsetTop - headerHeight;
            if(queryParams.get('accessible')) {
              this.updateFilter({ 'accessible': true }, true)
              window.scroll({ top: topOfElement, behavior: "smooth" });
            } else if (queryParams.get('roomType')) {
              this.updateFilter({ 'roomType': queryParams.get('roomType')}, true)
              window.scroll({ top: topOfElement, behavior: "smooth" });
            } else if(queryParams.size === 0) {
              this.updateFilter({}, true)
            }
          }
        })
      }
    },
    items: {
      handler() {
        this.$emit('item-update')
      },
      deep: true
    },
    serverItems: {
      handler(val) {
        this.loadItems({ items: val, total: val.length })
      },
      deep: true
    }
  },
  created() {
    this.pagination.$limit = (this.limitOverwrite || this.defaultLimit)
  },
  async mounted() {
    if (this.internalScroll) {
      this.calculateScroll()
    }
    if (this.serverItems) {
      await this.loadItems({ items: this.serverItems, total: this.serverItems.length })
    }
    if (!this.isSitecore) {
      this.isMounted = true
    }
  },
  methods: {
    calculateScroll() {
      if (this.height) {
        this.calculatedHeight = this.height + 'px'
      } else {
        const listBox = this.$refs.listWrapper.getBoundingClientRect()
        this.calculatedHeight = (this.wHeight - listBox.y) + 'px'
      }
    },
    updateFilter(filter, deepLinkEnabled) {
      this.filters = filter

      if(deepLinkEnabled) {
        const url = new URL(window.location.href);
        if(filter && Object.keys(filter).length > 0) {
          Object.keys(filter).forEach((key) => {
            if(key) {
              url.searchParams.forEach((i, k) => url.searchParams.delete(k))
              url.searchParams.set(key, filter[key]);
            }
          })
        } else {
          url.searchParams.forEach((i, k) => url.searchParams.delete(k))
        }
        window.history.replaceState(null, null, url)
      }
    },
    loadItems({ items, total }) {
      return new Promise((resolve) => {
        this.loadedItems = items
          //.map(item => this.transformDates(item))
          .map((item, index) => this.ensureId(item, index))
        return resolve({
          data: this.loadedItems,
          total: total || items.length
        })
      })
    },
    transformDates(obj = {}) {
      const newObj = {}
      const keys = Object.keys(obj)
      keys.forEach(key => {
        const value = obj[key]
        newObj[key] = getDateOrValue(value, undefined, true)
      })
      return newObj
    },
    ensureId(item, index) {
      if (item.id) {
        return item
      } else if (this.itemIndexes) {
        let id
        if (Array.isArray(this.itemIndexes)) {
          id = this.itemIndexes.map(prop => item[prop]).join('-')
        } else {
          id = item[this.itemIndexes]
        }
        return {
          id,
          ...item
        }
      } else {
        return {
          id: index,
          ...item
        }
      }
    }
  }
}
